// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/TermoContingencial/New/:id?',
  name: 'newTermoContingencial',
  component: () => import('modules/term/Index.vue'),
  meta: {
    breadcrumbs: [
      {
        text: 'Novo Smart',
        name: 'Dashboard'
      },
      {
        text: 'Termo Contingencial',
        name: 'TermoContingencial'
      },
      {
        text: 'Novo',
        name: 'newTermoContingencial'
      }
    ]
  },
  beforeEnter: (to, from, next) => {
    if (document.referrer.includes('consumer') && from && from.name !== 'TermoContingencial') {
      next('/consumer');
    }
    if (hasPermission('web.termo_contingencial.visualizar')) {
      next();
    } else {
      next('/');
    }
  }
};
